import { useState } from 'react';

type OpenModalArgs = {
  productID: string;
  accountID: string;
};

type UseRemoveProductModal = {
  productID: string;
  accountID: string;
  visible: boolean;
  openModal: (args: OpenModalArgs) => void;
  closeModal: () => void;
};

export const useRemoveProductModal = (): UseRemoveProductModal => {
  const [visible, setVisible] = useState(false);
  const [productID, setProductID] = useState('');
  const [accountID, setAccountID] = useState('');

  const openModal = ({
    productID: nextProductID,
    accountID: nextAccountID,
  }: OpenModalArgs) => {
    setProductID(nextProductID);
    setAccountID(nextAccountID);
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  return {
    productID,
    accountID,
    visible,
    openModal,
    closeModal,
  };
};
